<template>
    <!-- mobile title -->
    <div class="mobile-title">
      <div class="mobile-title-area">
        <div class="line"></div>
        <div class="title">{{title}}</div>
        <div class="little-title">{{subTitle}}</div>
      </div>
    </div>
</template>

<script>
  export default {
    props: {
      title: {
        type: String, default: "",
      },
      subTitle: {
        type: String, default: ""
      }
    },
    data() {
      return {

      }
    },
    methods: {

    }
}
</script>
<style scoped>
  .mobile-title {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }

    .mobile-title .mobile-title-area {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 15px;
    }

      .mobile-title .mobile-title-area .line {
        width: 50px;
        height: 4px;
        background: #006DFF;
        border-radius: 2px;
      }

      .mobile-title .mobile-title-area .title {
        font-family: Source Han Sans CN;
        /*font-weight: bold;*/
        font-size: 27px;
        color: #333333;
        line-height: 44px;
        margin: 5px 0;
      }

      .mobile-title .mobile-title-area .little-title {
        font-family: Arial;
        font-weight: 400;
        font-size: 14px;
        color: #999999;
        line-height: 1;
      }

</style>



// WEBPACK FOOTER //
// src/components/mobile-title/mobile-title.vue